import { useSelector } from "react-redux";

import { selectContactIdsBeingRevealed, selectNotRevealedContactsIds } from "../store/selectors";

export const useIsContactBeingRevealed = (id: string): boolean => {
    const contactIdsBeingRevealed = useSelector(selectContactIdsBeingRevealed);
    return contactIdsBeingRevealed.includes(id);
};

export const useIsContactNotRevealed = (id: string): boolean => {
    const notRevealedContactsIds = useSelector(selectNotRevealedContactsIds);
    return notRevealedContactsIds.includes(id);
};
